<div class="modal-header">
    <h4 class="modal-title pull-left">
        <!-- {{itemToSave.libelle}} -->
        Produit
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busyGet,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">
                
                
<div class="row">
    <div class="col-md-10">
        <div class="row">
            <div disabled class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                style="padding-left: 5px; padding-right: 5px;">
                <label>Codification:
                    <span class="required_champs">*</span>
                </label>
                <input class="form-control custom-input" disabled
                    placeholder="Codification" autocomplete="off"
                    [(ngModel)]="itemToSave.codification" name="codification" autocomplete="off"
                    type="text" />
            </div>

            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                style="padding-left: 5px; padding-right: 5px">
                <label>Libellé :
                    <span class="required_champs">*</span>
                </label>
                <input disabled class="form-control custom-input" placeholder="Libellé"
                    autocomplete="off" [(ngModel)]="itemToSave.libelle" name="libelle"
                    autocomplete="off" type="text" />
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                <label>Mode reconduction :
                    <span class="required_champs">*</span>
                </label>
                
                <input disabled class="form-control custom-input"
                [(ngModel)]="itemToSave.mode_reconduction_libelle" name="mode_reconduction_libelle"
                autocomplete="off" type="text"  />
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                <label>Mode de tarification :
                    <span class="required_champs">*</span>
                </label>
                
                <input disabled class="form-control custom-input"
                [(ngModel)]="itemToSave.mode_tarification_libelle" name="mode_tarification_libelle"
                autocomplete="off" type="text"  />
            </div>

            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                <label>Mode de fractionnement :
                    <span class="required_champs">*</span>
                </label>
               
                <input disabled class="form-control custom-input"
                [(ngModel)]="itemToSave.mode_fractionnement_libelle" name="mode_fractionnement_libelle"
                autocomplete="off" type="text"  />
            </div>

            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                style="padding-left: 5px; padding-right: 5px">
                <label>Taux de couverture:
                    <span class="required_champs">*</span>
                </label>
                <br>
                <input disabled class="form-control custom-input"
                    [(ngModel)]="itemToSave.taux_couverture" name="taux_couverture"
                    autocomplete="off" type="text" mask="000" />
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                style="padding-left: 5px; padding-right: 5px">
                <label>Nombre pers. par famille:
                    <span class="required_champs">*</span>
                </label>
                <br>
                <input disabled class="form-control custom-input"
                    [(ngModel)]="itemToSave.nombre_personnes_famille"
                    name="nombre_personnes_famille" autocomplete="off" type="text"
                    mask="separator" />
            </div>

            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                style="padding-left: 5px; padding-right: 5px">
                <label>Plafond annuel collège:
                    <!-- <span class="required_champs">*</span> -->
                </label>
                <input disabled class="form-control custom-input" placeholder="Plafond annuel collège"
                    autocomplete="off" [(ngModel)]="itemToSave.plafond_annuel_college"
                    name="plafond_annuel_college" autocomplete="off" type="text"
                    mask="separator" />
            </div>

            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                style="padding-left: 5px; padding-right: 5px">
                <label>Plafond annuel famille:
                    <!-- <span class="required_champs">*</span> -->
                </label>
                <input disabled class="form-control custom-input" placeholder="Plafond annuel famille"
                    autocomplete="off" [(ngModel)]="itemToSave.plafond_annuel_famille"
                    name="plafond_annuel_famille" autocomplete="off" type="text"
                    mask="separator" />
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                style="padding-left: 5px; padding-right: 5px">
                <label
                    [ngClass]="{'isSelectedItem':itemToSave.reseau_de_soin_id}">Réseau de soin :
                    <span class="required_champs">*</span>
                </label>

                <input disabled class="form-control custom-input" placeholder="Plafond annuel famille"
                    autocomplete="off" [(ngModel)]="itemToSave.reseau_de_soin_libelle"
                    name="reseau_de_soin_libelle" autocomplete="off" type="text"
                    mask="separator" />

            </div>

            <div *ngIf="itemToSave.mode_tarification_selected?.code =='FAMILLE'"
                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                style="padding-left: 5px; padding-right: 5px">
                <label>Prime par famille:
                    <!-- <span class="required_champs">*</span> -->
                </label>
                <input disabled class="form-control custom-input" placeholder="Prime par famille"
                    autocomplete="off" [(ngModel)]="itemToSave.prime_par_famille"
                    name="prime_par_famille" autocomplete="off" type="text" mask="separator" />
            </div>

        </div>
    </div>
    <div class="col-md-2">
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1"
                style="padding-left: 5px; padding-right: 5px">

                <input disabled [(ngModel)]="itemToSave.is_couverture_hospitalisation"
                    id="is_couverture_hospitalisation" name="is_couverture_hospitalisation"
                    autocomplete="off" type="checkbox" />
                <label for="is_couverture_hospitalisation">Couverture hospitalisation?
                </label>
                <br>
                <input disabled id="is_couverture_consultation"
                    [(ngModel)]="itemToSave.is_couverture_consultation"
                    name="is_couverture_consultation" autocomplete="off" type="checkbox" />
                <label for="is_couverture_consultation">Couverture consultation?
                </label>
                <br>
                <input disabled id="is_couverture_dentaire"
                    [(ngModel)]="itemToSave.is_couverture_dentaire"
                    name="is_couverture_dentaire" autocomplete="off" type="checkbox" />
                <label for="is_couverture_dentaire">Couverture dentaire?
                </label>
                <br>
                <input disabled id="is_couverture_optique" [(ngModel)]="itemToSave.is_couverture_optique"
                    name="is_couverture_optique" autocomplete="off" type="checkbox" />
                <label for="is_couverture_optique">Couverture optique?
                </label>

            </div>
        </div>

    </div>

</div>
<mat-tab-group mat-align-tabs="start" #tabGroup (selectedIndexChange)="selectedChangeValue($event)"
    [(selectedIndex)]="indiceTab">
    <mat-tab label="BASIQUE">
        <div *ngIf="indiceTab == 0" style="overflow-x: hidden">
            <div class="col col-md-12">
                <table class="table table-stripped table-bordered table-hover">
                    <thead>
                        <tr class="custom-table-head">

                            <th>Type</th>
                            <th>Prime</th>
                            <th>Plafond</th>
                            <th>Age min</th>
                            <th>Age max</th>
                            <th>Nombre autorisé</th>
                            <th>Nombre suppl. autorisé</th>
                            <th>Surprime</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="cursor: pointer;">
                            <td>Assuré</td>
                            <td><input disabled class="form-control custom-input" autocomplete="off"
                                    [(ngModel)]="itemToSave.prime_par_assure" name="prime_par_assure" autocomplete="off"
                                    type="text" mask="separator" />
                            </td>
                            <td>
                                <input disabled class="form-control custom-input" [(ngModel)]="itemToSave.plafond_annuel_assure"
                                    name="plafond_annuel_assure" autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td>
                                <input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_min_assure"
                                    name="age_min_assure" autocomplete="off" type="text" mask="separator" />
                            </td>

                            <td><input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_max_assure"
                                    name="age_max_assure" autocomplete="off" type="text" mask="separator" /></td>
                            <td><input disabled class="form-control custom-input" [(ngModel)]="itemToSave.nombre_assure"
                                    name="nombre_assure" autocomplete="off" type="text" mask="separator" /></td>
                            <td><input disabled class="form-control custom-input"
                                    [(ngModel)]="itemToSave.nombre_assure_supplementaire"
                                    name="nombre_assure_supplementaire" autocomplete="off" type="text"
                                    mask="separator" /></td>
                            <td><input disabled class="form-control custom-input"
                                    [(ngModel)]="itemToSave.prime_assure_supplementaire"
                                    name="prime_assure_supplementaire" autocomplete="off" type="text"
                                    mask="separator" /></td>
                        </tr>
                        <tr style="cursor: pointer;">
                            <td>Conjoint(s)</td>
                            <td><input disabled [class.isNotConsidered]="is_tarif_famille" class="form-control custom-input"
                                    autocomplete="off" [(ngModel)]="itemToSave.prime_par_conjoint"
                                    name="prime_par_conjoint" autocomplete="off" type="text" mask="separator" /></td>
                            <td><input disabled class="form-control custom-input" autocomplete="off"
                                    [(ngModel)]="itemToSave.plafond_annuel_conjoint" name="plafond_annuel_conjoint"
                                    autocomplete="off" type="text" mask="separator" /></td>
                            <td>
                                <input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_min_conjoint"
                                    name="age_min_conjoint" autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td> <input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_max_conjoint"
                                    name="age_max_conjoint" autocomplete="off" type="text" mask="separator" /></td>
                            <td><input disabled (keyup)="get_nombre_par_famille()" class="form-control custom-input"
                                    [(ngModel)]="itemToSave.nombre_conjoint_famille" name="nombre_conjoint_famille"
                                    autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td><input disabled class="form-control custom-input"
                                    [(ngModel)]="itemToSave.nombre_conjoint_sup_famille"
                                    name="nombre_conjoint_sup_famille" autocomplete="off" type="text"
                                    mask="separator" /></td>
                            <td><input disabled [class.isNotConsidered]="is_tarif_famille" class="form-control custom-input"
                                    [(ngModel)]="itemToSave.prime_par_conjoint_supplementaire"
                                    name="prime_par_conjoint_supplementaire" autocomplete="off" type="text"
                                    mask="separator" /></td>
                        </tr>
                        <tr style="cursor: pointer;">
                            <td>Enfant(s)</td>
                            <td>
                                <input disabled [class.isNotConsidered]="is_tarif_famille" class="form-control custom-input"
                                    autocomplete="off" [(ngModel)]="itemToSave.prime_par_enfant" name="prime_par_enfant"
                                    autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td>
                                <input disabled class="form-control custom-input" autocomplete="off"
                                    [(ngModel)]="itemToSave.plafond_annuel_enfant" name="plafond_annuel_enfant"
                                    autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td><input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_min_enfant"
                                    name="age_min_enfant" autocomplete="off" type="text" mask="separator" /></td>
                            <td><input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_max_enfant"
                                    name="age_max_enfant" autocomplete="off" type="text" mask="separator" /></td>
                            <td>
                                <input disabled (keyup)="get_nombre_par_famille()" class="form-control custom-input"
                                    [(ngModel)]="itemToSave.nombre_enfant_famille" name="nombre_enfant_famille"
                                    autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td>
                                <input disabled class="form-control custom-input"
                                    [(ngModel)]="itemToSave.nombre_enfant_sup_famille" name="nombre_enfant_sup_famille"
                                    autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td><input disabled [class.isNotConsidered]="is_tarif_famille" class="form-control custom-input"
                                    [(ngModel)]="itemToSave.prime_par_enfant_suplementaire"
                                    name="prime_par_enfant_suplementaire" autocomplete="off" type="text"
                                    mask="separator" /></td>
                        </tr>
                        <tr style="cursor: pointer;">
                            <td>Ascendant(s)</td>
                            <td>
                                <input disabled [class.isNotConsidered]="is_tarif_famille" class="form-control custom-input"
                                    autocomplete="off" [(ngModel)]="itemToSave.prime_par_ascendant"
                                    name="prime_par_ascendant" autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td>
                                <input disabled class="form-control custom-input" autocomplete="off"
                                    [(ngModel)]="itemToSave.plafond_annuel_ascendant" name="plafond_annuel_ascendant"
                                    autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td>
                                <input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_min_ascendant"
                                    name="age_min_ascendant" autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td><input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_max_ascendant"
                                    name="age_max_ascendant" autocomplete="off" type="text" mask="separator" /></td>
                            <td>
                                <input disabled (keyup)="get_nombre_par_famille()" class="form-control custom-input"
                                    [(ngModel)]="itemToSave.nombre_ascendant_famille" name="nombre_ascendant_famille"
                                    autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td><input disabled class="form-control custom-input"
                                    [(ngModel)]="itemToSave.nombre_ascendant_sup_famille"
                                    name="nombre_ascendant_sup_famille" autocomplete="off" type="text"
                                    mask="separator" /></td>
                            <td>
                                <input disabled [class.isNotConsidered]="is_tarif_famille" class="form-control custom-input"
                                    [(ngModel)]="itemToSave.prime_par_ascendant_supplementaire"
                                    name="prime_par_ascendant_supplementaire" autocomplete="off" type="text"
                                    mask="separator" />
                            </td>
                        </tr>
                        <tr style="cursor: pointer;">
                            <td>Autre(s)</td>
                            <td>
                                <input disabled [class.isNotConsidered]="is_tarif_famille" class="form-control custom-input"
                                    autocomplete="off" [(ngModel)]="itemToSave.prime_par_autre_parent"
                                    name="prime_par_autre_parent" autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td>
                                <input disabled class="form-control custom-input" autocomplete="off"
                                    [(ngModel)]="itemToSave.plafond_annuel_autre_parent"
                                    name="plafond_annuel_autre_parent" autocomplete="off" type="text"
                                    mask="separator" />
                            </td>
                            <td>
                                <input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_min_autre_parent"
                                    name="age_min_autre_parent" autocomplete="off" type="text" mask="separator" />
                            </td>
                            <td><input disabled class="form-control custom-input" [(ngModel)]="itemToSave.age_max_autre_parent"
                                    name="age_max_autre_parent" autocomplete="off" type="text" mask="separator" /></td>
                            <td><input disabled (keyup)="get_nombre_par_famille()" class="form-control custom-input"
                                    [(ngModel)]="itemToSave.nombre_autre_parent_famille"
                                    name="nombre_autre_parent_famille" autocomplete="off" type="text"
                                    mask="separator" /></td>
                            <td><input disabled class="form-control custom-input"
                                    [(ngModel)]="itemToSave.nombre_autre_parent_sup_famille"
                                    name="nombre_autre_parent_sup_famille" autocomplete="off" type="text"
                                    mask="separator" /></td>
                            <td>
                                <input disabled [class.isNotConsidered]="is_tarif_famille" class="form-control custom-input"
                                    [(ngModel)]="itemToSave.prime_par_autre_parent_supplementaire"
                                    name="prime_par_autre_parent_supplementaire" autocomplete="off" type="text"
                                    mask="separator" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </mat-tab>

    <mat-tab label="AVANCE">
        <div *ngIf="indiceTab == 1" style="overflow-x: hidden">
            <div class="col col-md-12">
                <div class="row">

                    <div class="col col-md-3">
                        <label>Statut :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select disabled (change)="onChangeStatut()" [(ngModel)]="itemToSave.statut_id"
                            placeholder="Choisissez statut" name="statut_id" id="statut_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsStatut" [value]="item.id">{{
                                item?.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col col-md-2">
                        <label>Age min :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Age min" autocomplete="off"
                            [(ngModel)]="itemToAdd.age_min" name="age_min" autocomplete="off" type="number" />
                    </div>
                    <div class="col col-md-2">
                        <label>Age max :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Age max" autocomplete="off"
                            [(ngModel)]="itemToAdd.age_max" name="age_max" autocomplete="off" type="number" />
                    </div>
                    <div class="col col-md-3">
                        <label>Prime :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Prime" autocomplete="off"
                            [(ngModel)]="itemToAdd.prime" name="prime" autocomplete="off" type="text"
                            mask="separator" />
                    </div>
                    <div class="col col-md-1" style="text-align: right;">
                        <br>
                        <button disabled class="btn btn-info" (click)="onAddItemToTable()"><i class="fa fa-plus"></i></button>
                    </div>


                    <div class="table-responsive" style="min-height:170px;max-height: 170px;overflow:auto;">
                        <table class="table table-stripped table-bordered table-hover">
                            <thead>
                                <tr class="custom-table-head">
                                    <th style="width: 9%;">
                                        <a style="cursor: pointer;margin-top: 5px;"
                                            (click)="currentPage = 0; getItemsPrimeByProduit()" title="Actualiser">
                                            <i class="fa fa-redo-alt"></i></a>
                                    </th>
                                    <th>Age min</th>
                                    <th>Age max</th>
                                    <th>Prime</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of itemsPrimeByProduit; let indice = index"
                                    style="cursor: pointer;">
                                    <td [class.isNotConsidered]="is_tarif_famille">{{indice+1}}
                                    </td>
                                    <td [class.isNotConsidered]="is_tarif_famille">
                                        {{item.age_min}}</td>
                                    <td [class.isNotConsidered]="is_tarif_famille">
                                        {{item.age_max}}</td>
                                    <td [class.isNotConsidered]="is_tarif_famille">{{item.prime
                                        | mask:'separator'}}</td>
                                    <td><i style="color: red;" class="fa fa-trash"
                                            (click)="itemsPrimeByProduit.splice(indice,1)"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </mat-tab>


</mat-tab-group>
<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1" style="padding-left: 5px; padding-right: 5px">
    <label>Description:
        <span class="required_champs">*</span>
    </label>
    <textarea disabled class="form-control custom-input" [(ngModel)]="itemToSave.description" name="description"
        placeholder="Description" id="" cols="30" rows="3"></textarea>
</div>

            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
     

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>